import { styled } from '@mui/material';

export const StyledFieldSet = styled('fieldset')(() => ({
  padding: 0,
  margin: 0,
  border: 0,
}));

export const ResourceP = styled('p')(({ theme }) => ({
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '12px',
  // Themed secondary text: ~grey[700] in light, high-contrast in dark
  // (was hardcoded grey[700], which was unreadable on the dark surface).
  color: theme.palette.text.secondary,
}));
